module.exports = __webpack_public_path__ + "assets/img/k-logo.7f2cf845.svg";